"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderDirection = exports.ReportStatus = exports.OlapicTypeEnum = exports.MediaItemPosition = void 0;
/* istanbul ignore file @preserve */
let MediaItemPosition = exports.MediaItemPosition = /*#__PURE__*/function (MediaItemPosition) {
  MediaItemPosition[MediaItemPosition["gallery"] = 9] = "gallery";
  MediaItemPosition[MediaItemPosition["slider3"] = 0] = "slider3";
  return MediaItemPosition;
}({});
let SliderDirection = exports.SliderDirection = /*#__PURE__*/function (SliderDirection) {
  SliderDirection["left"] = "left";
  SliderDirection["right"] = "right";
  return SliderDirection;
}({});
let ReportStatus = exports.ReportStatus = /*#__PURE__*/function (ReportStatus) {
  ReportStatus["new"] = "new";
  ReportStatus["send"] = "send";
  ReportStatus["sending"] = "sending";
  ReportStatus["sent"] = "sent";
  ReportStatus["error"] = "error";
  return ReportStatus;
}({});
let OlapicTypeEnum = exports.OlapicTypeEnum = /*#__PURE__*/function (OlapicTypeEnum) {
  OlapicTypeEnum["Category"] = "Category";
  OlapicTypeEnum["FrontPage"] = "FrontPage";
  OlapicTypeEnum["Gallery"] = "Gallery";
  OlapicTypeEnum["ProductDetails"] = "ProductDetails";
  return OlapicTypeEnum;
}({});
